const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN?.trim() || undefined;
const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_APP_ENV || process.env.NODE_ENV || 'development';

type SentryEvent = {
  request?: {
    headers?: Record<string, unknown>;
    cookies?: string;
    data?: unknown;
  };
  user?: Record<string, unknown>;
};

function scrubRequestHeaders(headers: Record<string, unknown> | undefined) {
  if (!headers) {
    return;
  }

  delete headers.authorization;
  delete headers.cookie;
  delete headers['x-forwarded-for'];
  delete headers['x-real-ip'];
  delete headers['cf-connecting-ip'];
}

export function createSentryOptions(): any {
  return {
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
    ],
    beforeSend(event: SentryEvent) {
      if (event.request) {
        scrubRequestHeaders(event.request.headers);
        delete event.request.cookies;
        delete event.request.data;
      }

      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }

      if (process.env.NODE_ENV === 'development' && !process.env.SENTRY_DEBUG) {
        return null;
      }

      return event;
    },
  };
}
